import Headroom from 'headroom.js';

const header = document.querySelector('.c-header');
let headerHeight;
let latestKnownScrollY = 0;
let ticking = false;

const update = function() {
  ticking = false;
  const currentScrollY = latestKnownScrollY;

  if (currentScrollY > headerHeight) {
    header.classList.add('c-header--first');
  } else {
    header.classList.remove('c-header--first');
  }

  if (currentScrollY > headerHeight + 100) {
    header.classList.add('c-header--second');
  } else {
    header.classList.remove('c-header--second');
  }
};

const requestTick = function() {
  if (!ticking) {
    requestAnimationFrame(update);
  }

  ticking = true;
};

const onScroll = function() {
  latestKnownScrollY = window.scrollY;
  requestTick();
};

const stickyHeader = function() {
  headerHeight = header.offsetHeight;

  const options = {
    classes: {
      initial: 'c-header--initialised',
      pinned: 'c-header--pinned',
      unpinned: 'c-header--unpinned',
      top: 'c-header--top',
      notTop: 'c-header--not-top',
      bottom: 'c-header--bottom',
      notBottom: 'c-header--not-bottom',
    },
    offset: headerHeight + 200,
    tolerance: {
      up: 5,
      down: 2,
    },
  };

  const headroom = new Headroom(header, options);
  headroom.init();
  window.addEventListener('scroll', onScroll, false);
};

export default stickyHeader;



// WEBPACK FOOTER //
// ./src/scripts/modules/sticky-header.js